import React, { useEffect, useRef } from 'react';
import Goldchart from './components/goldchart/Goldchart';
import "./app.css"
import Liverate from './pages/liverate/Liverate';
import { BrowserRouter, Route, Router, Routes, useLocation } from 'react-router-dom';
import Goldrate from './pages/Goldrate/Goldrate';
import Silverrate from './pages/Silverrate/Silverrate';
import Sidebar from './components/sidebar/Sidebar';
import Header from './components/header/Header';
import Newspage from './pages/newspage/Newspage';
import CurrencyConverter from './components/currencyconverter/CurrencyConverter';
import Homepage from './pages/Homepage/Homepage';
import MainHomeSection from './components/mainHome/mainHomeSection';
import Footer from './components/footer/Footer';
import AdBanner from './components/adsense/AdBanner';

function App() {
  const container = useRef();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/gold" || location.pathname === "/silver") {
      if (container.current) {
        container.current.innerHTML = '';
      }

      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
      script.type = "text/javascript";
      script.async = true;

      script.innerHTML = `
      {
        "lineWidth": 2,
        "lineType": 0,
        "chartType": "area",
        "fontColor": "rgb(106, 109, 120)",
        "gridLineColor": "rgba(46, 46, 46, 0.06)",
        "volumeUpColor": "rgba(34, 171, 148, 0.5)",
        "volumeDownColor": "rgba(247, 82, 95, 0.5)",
        "backgroundColor": "#ffffff",
        "widgetFontColor": "#0F0F0F",
        "upColor": "#22ab94",
        "downColor": "#f7525f",
        "borderUpColor": "#22ab94",
        "borderDownColor": "#f7525f",
        "wickUpColor": "#22ab94",
        "wickDownColor": "#f7525f",
        "colorTheme": "light",
        "isTransparent": false,
        "locale": "en",
        "chartOnly": false,
        "scalePosition": "right",
        "scaleMode": "Normal",
        "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
        "valuesTracking": "1",
        "changeMode": "price-and-percent",
        "symbols": [
          [
            "GOLD",
            "FX_IDC:XAUINRG|1D"
          ],
          [
            "SILVER",
            "FX_IDC:XAGINRK|1D"
          ]
        ],
        "dateRanges": [
          "1d|3",
          "1m|30",
          "3m|60",
          "12m|1D",
          "60m|1W",
          "all|1M"
        ],
        "fontSize": "10",
        "headerFontSize": "medium",
        "autosize": true,
        "width": "100%",
        "height": "450",
        "noTimeScale": false,
        "hideDateRanges": false,
        "hideMarketStatus": false,
        "hideSymbolLogo": false
      }`;

      if (container.current) {
        container.current.appendChild(script);
      }
    } else {
      if (container.current) {
        container.current.innerHTML = '';
      }
    }

    return () => {
      if (container.current) {
        container.current.innerHTML = '';
      }
    };
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div className="App">
        <div className="container">

          {location.pathname == '/' && <MainHomeSection />}

          {/* Top Ad start */}
          <div className="Top-Ad">
            <AdBanner adSlot="9876543210" />
          </div>
          {/* Top Ad end */}

          <div className="row app-row">

            {/* Left Ad start */}
            <div className="Left-Ad">
              <AdBanner adSlot="9876543210" />
            </div>
            {/* Left Ad end */}

            {/* content start */}
            <div className="main-content-div">
              <div className="main-content">
                {(location.pathname === "/gold" || location.pathname === "/silver") && <Liverate />}
                <Routes>
                  <Route path='/' element={<Homepage />}></Route>
                  <Route path='/gold' element={<Goldrate />}></Route>
                  <Route path='/silver' element={<Silverrate />}></Route>
                  <Route path='/news' element={<Newspage />}></Route>
                  <Route path='/currency' element={<CurrencyConverter />}></Route>
                </Routes>
                {
                  (location.pathname === "/gold" || location.pathname === "/silver") && (<>
                    <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%", padding: "15px", }}>
                      <div className="tradingview-widget-container__widget" style={{ height: "calc(100% - 32px)", width: "100%" }}></div>
                      <div className="tradingview-widget-copyright"><a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank"><span className="blue-text">Track all markets on TradingView</span></a></div>
                    </div>
                  </>)
                }


              </div>
              <div className="sidebar-div">
                <Sidebar />
              </div>
            </div>
            {/* content end */}

            {/* Right Ad start */}
            <div className="Right-Ad">
              <AdBanner adSlot="9876543210" />
            </div>
            {/* Right Ad end */}

          </div>

          {/* Bottom Ad start */}
          <div className="Bottom-Ad">
            <AdBanner adSlot="9876543210" />
          </div>
          {/* Bottom Ad end */}

        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
